import { useEffect } from 'react';

export default function LegalModal({ open, title, children, onClose }) {
  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose?.();
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4" role="dialog" aria-modal="true">
      {/* Overlay (click para cerrar) */}
      <button
        type="button"
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
        aria-label="Cerrar"
      />

      {/* Panel */}
      <div className="relative w-full max-w-3xl rounded-3xl border border-white/15 bg-slate-950/80 text-slate-100 shadow-2xl backdrop-blur-xl">
        <div className="flex items-start justify-between gap-6 p-6 border-b border-white/10">
          <div>
            <h3 className="text-xl md:text-2xl font-black tracking-tight">{title}</h3>
            <p className="text-slate-300 text-sm mt-1">Next Global Media</p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="w-10 h-10 rounded-2xl border border-white/15 bg-white/5 hover:bg-white/10 transition flex items-center justify-center"
            aria-label="Cerrar modal"
          >
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="p-6 max-h-[70vh] overflow-y-auto">
          <div className="prose prose-invert prose-p:leading-relaxed prose-li:my-1 max-w-none">
            {children}
          </div>
        </div>

        <div className="p-6 border-t border-white/10 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 text-xs font-black tracking-[0.22em] uppercase bg-lime-400 text-slate-950 hover:bg-lime-500 transition"
          >
            Aceptar
          </button>
        </div>
      </div>
    </div>
  );
}